import React from 'react';
import { ChevronRight, LayoutDashboard, Plane, Compass } from 'lucide-react';

const SaveDeal = () => {
  return (
    <div className="w-full max-w-full">
      <div className="rounded-3xl bg-white dark:bg-[#0F172A] p-5 md:p-7 shadow-xs border border-slate-100 dark:border-slate-800/80 transition-colors duration-300">
        
        <div className="flex items-center justify-between mb-6 pb-4 border-b border-slate-50 dark:border-slate-800/40">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-amber-50 dark:bg-amber-500/10 text-[#D4AF37] flex items-center justify-center shadow-2xs">
              <LayoutDashboard size={18} className="stroke-[2.2]" />
            </div>
            <div>
              <h2 className="text-base md:text-lg font-black text-slate-900 dark:text-white tracking-tight">
                Saved Intelligence
              </h2>
              <p className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest mt-0.5">
                Monitored Flight Deals
              </p>
            </div>
          </div>

          <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-pulse" />
        </div>

        <div className="space-y-3.5">
          {[
            {
              route: "JFK → Paris",
              carrier: "Air France",
              pts: "55,000",
              class: "Business",
              classTheme: "bg-purple-50 dark:bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-100 dark:border-purple-500/20",
            },
            {
              route: "SFO → Tokyo",
              carrier: "ANA Miles",
              pts: "75,000",
              class: "First Class",
              classTheme: "bg-amber-50 dark:bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-100 dark:border-amber-500/20",
            },
          ].map((deal, i) => (
            <div
              key={i}
              className="group rounded-2xl border border-slate-100 dark:border-slate-800/60 bg-slate-50/40 dark:bg-[#0A101D]/40 p-4 flex items-center justify-between hover:bg-white dark:hover:bg-[#0A101D] hover:border-amber-500/30 dark:hover:border-amber-500/20 hover:scale-[1.01] hover:shadow-md hover:shadow-slate-100/50 dark:hover:shadow-none transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-3.5 min-w-0">
                <div className="w-10 h-10 rounded-xl bg-white dark:bg-[#0F172A] text-slate-400 dark:text-slate-500 group-hover:text-[#D4AF37] group-hover:bg-amber-50 dark:group-hover:bg-amber-500/10 border border-slate-200/60 dark:border-slate-800 shrink-0 flex items-center justify-center transition-colors shadow-2xs">
                  <Plane size={16} className="group-hover:rotate-45 transition-transform duration-300" />
                </div>
                
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="text-sm font-black text-slate-900 dark:text-white tracking-tight truncate">
                      {deal.route}
                    </h3>
                    <span className={`text-[9px] px-2 py-0.5 font-black uppercase tracking-wider rounded-md border ${deal.classTheme}`}>
                      {deal.class}
                    </span>
                  </div>
                  <p className="text-xs font-semibold text-slate-400 dark:text-slate-500 mt-1 flex items-center gap-1">
                    <Compass size={11} className="text-slate-300 dark:text-slate-600" />
                    {deal.carrier}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 shrink-0 ml-4">
                <div className="text-right">
                  <p className="text-sm md:text-base font-black text-[#D4AF37] tracking-tight">
                    {deal.pts}
                  </p>
                  <p className="text-[9px] font-black uppercase text-slate-400 dark:text-slate-500 tracking-widest mt-0.5">
                    Miles Required
                  </p>
                </div>
                
                <div className="w-7 h-7 rounded-lg bg-white dark:bg-[#0F172A] border border-slate-200/40 dark:border-slate-800 flex items-center justify-center text-slate-300 dark:text-slate-600 group-hover:text-[#D4AF37] group-hover:border-amber-500/30 transition-colors shadow-2xs">
                  <ChevronRight
                    size={14}
                    className="group-hover:translate-x-0.5 transition-transform duration-200 stroke-[2.5]"
                  />
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default SaveDeal;